import { mergeMap } from './mergeMap';
export var flatMap = mergeMap;
//# sourceMappingURL=flatMap.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/dist/esm5/internal/operators/flatMap.js
// module id = 1232
// module chunks = 0